import { FormNodeCartModel } from '../../../../../shared/kiosk';
import { AbstractElementEditor } from './AbstractElementEditor';

export class CartEditor extends AbstractElementEditor<FormNodeCartModel> {
  public getDescription(): string {
    return 'Cart';
  }

  public getName(): string {
    return 'Cart';
  }

  public getIcon(): string {
    return 'shopping_cart';
  }
}
